import React from 'react';
import { Col } from 'antd';
import { Title } from '@/components/Typography';

interface LabelProps {
	children: string;
}

export function Label({ children }: Readonly<LabelProps>) {
	return (
		<Col span={24}>
			<Title level={4}>{children}</Title>
		</Col>
	);
}
